import { unsubLinks } from "../constants";
import { sendData } from "../analytics/sendData";

export const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  return parts[0];
};

export const formatDate = (date, format) => {
  let d = new Date(date);
  let day = d.getDate() > 9 ? d.getDate().toString() : `0${d.getDate()}`;
  let month =
    d.getMonth() + 1 > 9
      ? (d.getMonth() + 1).toString()
      : `0${d.getMonth() + 1}`;
  let year = d.getFullYear();
  switch (format) {
    case "DD/MM/YYYY":
      return `${day}/${month}/${year}`;
    case "MM/DD/YYYY":
      return `${month}/${day}/${year}`;
    default:
      return `${year}/${month}/${day}`;
  }
};

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return null;
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const getDomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  return parts[1];
};

export const setLanguage = (countryCode) => {
  let localLanguage = "";
  console.log(countryCode);
  if (countryCode === "mx") {
    localLanguage = "es";
  } else if (countryCode === "gr" || countryCode === "gr-mobimilia") {
    localLanguage = "el";
  } else if (
    countryCode === "eg" ||
    countryCode === "ps" ||
    countryCode === "jo"
  ) {
    localLanguage = "ar";
  } else if (countryCode == "ie") {
    localLanguage = "en";
  } else if (countryCode == "pl") {
    localLanguage = "pl";
  } else if (countryCode == "vn") {
    localLanguage = "vi";
  } else if (countryCode == "rs") {
    localLanguage = "cy";
  } else {
    localLanguage = countryCode;
  }
  return localLanguage;
};

export const onUnsubClick = (e) => {
  e.preventDefault();
  const uid = JSON.parse(sessionStorage.getItem("uid"));
  const subDomain = JSON.parse(sessionStorage.getItem("countryCode"))
    ? JSON.parse(sessionStorage.getItem("countryCode")).countryCode
    : "";
  sendData("", "", "unsubscribe clicked");
  if (window.location.host.split(".")[0] == "dz" && subDomain == "fr") {
    window.open(
      `http://n.mobioastro.com/unsubscribe/dz?lang=fr&token=${uid.uid}`,
    );
  } else if (
    sessionStorage.getItem("staging") === "true" &&
    subDomain === "za"
  ) {
    window.open(
      `http://ads-za-yola.sam-media.com/unsubscribe/za1?country=qa&lang=en&token=${uid.uid}`,
    );
  } else if (window.location.host.split(".")[0] == "dz" && subDomain == "eg") {
    window.open(
      `http://n.mobioastro.com/unsubscribe/dz?lang=ar&token=${uid.uid}`,
    );
  } else if (window.location.host.includes("eg")) {
    if (subDomain === "en") {
      window.open(
        `http://n.mobioastro.com/unsubscribe/eg?lang=en&?token=${uid.uid}`,
      );
    } else if (subDomain === "eg") {
      window.open(`https://checksubscription.com/?c=eg`);
    }
  } else if (unsubLinks[subDomain])
    window.open(`${unsubLinks[subDomain]}${uid.uid}`);
};



// WEBPACK FOOTER //
// ./src/utils/helper.js